/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GeonamesAddendum
 */
export interface GeonamesAddendum {
  /**
   * The GeoNames feature code (for GeoNames results only).
   * @type {string}
   * @memberof GeonamesAddendum
   */
  featureCode: string;
}

/**
 * Check if a given object implements the GeonamesAddendum interface.
 */
export function instanceOfGeonamesAddendum(
  value: object,
): value is GeonamesAddendum {
  if (!("featureCode" in value) || value["featureCode"] === undefined)
    return false;
  return true;
}

export function GeonamesAddendumFromJSON(json: any): GeonamesAddendum {
  return GeonamesAddendumFromJSONTyped(json, false);
}

export function GeonamesAddendumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeonamesAddendum {
  if (json == null) {
    return json;
  }
  return {
    featureCode: json["feature_code"],
  };
}

export function GeonamesAddendumToJSON(json: any): GeonamesAddendum {
  return GeonamesAddendumToJSONTyped(json, false);
}

export function GeonamesAddendumToJSONTyped(
  value?: GeonamesAddendum | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    feature_code: value["featureCode"],
  };
}
